<script>
import niceFunctions from "@/helpers/niceFunctions"
export default {
    props: ['course'],
    data() {
        return {
            sendingApplication: false,
            showConfirmation: false,
            errors: [],
            registerForm: { full_name: '', email: '', email2: '', mobile_no: '', id: 0}
        }
    },   
    computed: {        
    },
    methods:
    {      
        sendApplication() {          
            this.errors = [];
            
            if(this.registerForm.full_name == '') {
                this.errors.push('Du måste mata in ett namn');
            }

            if(this.registerForm.email == '') {
                this.errors.push('Du måste mata in en email');
            }
            
            if(this.registerForm.email2 == '') {
                this.errors.push('Du måste mata in en bekräftelse-email');
            }
            
            if(this.registerForm.email2 != this.registerForm.email) {
                this.errors.push('Emailen stämmer inte överrens');
            }

            if(this.errors.length > 0) { return }

            this.registerForm.course_id = this.course.id;
            this.sendingApplication = true;

            var self = this;
            this.$communicator.post('public-course-apply/', this.registerForm)
                .then(function(data)
                {                                           
                    self.showConfirmation = true;  
                    self.sendingApplication = false;                                
                })
                .fail(function(error) {                                     
                }) 

        },
        backToCourses() {
            $(window).scrollTop(0);           
            this.$router.push({ name: niceFunctions.getPageName('courses') })
        }    
    }
}
</script>
<template>
    <div v-if="!showConfirmation" class="overflow-auto">
        <h3>Anmälan</h3>
        <div v-if="course.number_of_approved_participants >= course.max_number_of_participents">
            Kursen är dessvärre fullbokad. 
        </div>
        <div v-else>
            <div v-if="errors.length > 0" class="alert margin-bottom-15">
                <span style="font-weight: 400; display:block; margin: 10px;">Oj, något blev visst fel :( </span>
                    <div v-for="error in errors" style="margin: 3px 5px;">
                        * {{ error }}
                    </div>
                </div>
            <label>Ditt namn<span style="font-family: 'Courier New', Courier, monospace;">*</span></label>
            <input type="text" v-model="registerForm.full_name" style="border: 1px solid #ddd" />
            <div class="row-form">
                <div class="g-100"> 
                    <label>Din email<span style="font-family: 'Courier New', Courier, monospace;">*</span></label>
                    <input type="text" v-model="registerForm.email" style="border: 1px solid #ddd" />
                </div>            
                <div class="g-100"> 
                    <label>Bekräfta e-postadress<span style="font-family: 'Courier New', Courier, monospace;">*</span></label>
                    <input type="text" v-model="registerForm.email2" style="border: 1px solid #ddd" />
                </div>            
                <div class="g-50">
                    <label>Ditt mobilnummer</label>
                    <input type="text" v-model="registerForm.mobile_no" style="border: 1px solid #ddd" />
                </div>              
                <div class="g-50">                           
                    <button class="btn" @click="sendApplication" :disabled="sendingApplication">Skicka anmälan</button>
                </div>              
            </div>
        </div>
    </div>
    <div v-else>
        <h3>Tack för din anmälan!</h3>
        <p>Vi hör av oss med mer information när det närmar sig kursstart. :)</p>
    </div>

    <!-- <button class="btn" style="margin-top: 70px; width: auto; padding: 15px;"  @click="backToCourses">Tillbaka till kurser</button> -->
                  
</template>
<style scoped>

    button {
        width: calc(100% - 8px);
        margin-top: 25px;
        padding: 13px 0px;
        font-size: 12pt;
    }
</style>